import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.promise";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../services/apiService';
import { EventBus } from '../../services/eventbus.js';
import { flattenAccountsTree, getParents } from '../../utils/treeviewHelper';
import { mapState, mapGetters } from 'vuex';
import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'ViewAccountMgmtAccountMgmtOverview',
  props: {
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    var _this = this;

    return {
      tabItems: [],
      tabItem: null,
      isApiKeysVisible: false,
      accountsFilterEmpty: false,
      active: [],
      open: [],
      tenantSearch: null,
      tenantCreateDialog: false,
      tenantDeleteDialog: false,
      tenantDeleteId: -1,
      hasTenantManagePermission: false,
      tenants: [],
      tenantsList: [],
      selectedTenant: null,
      userSearch: null,
      usersIncludeAncestorAdmins: false,
      usersIncludeSubAccounts: false,
      apiKeySearch: null,
      apiKeysIncludeAncestorAdmins: false,
      apiKeysIncludeSubAccounts: false,
      tableLoading: false,
      currentMode: 'create',
      requiredRule: [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }],
      itemsLoadMore: false,
      isDialogCreateUserOpen: false,
      counter: 0
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions', 'openedTreeview'])), mapGetters({
    sessionAccess: 'authentication/access',
    sessionPrimaryTenantIds: 'authentication/primaryTenantIds',
    sessionUserId: 'authentication/userId'
  })), {}, {
    hasAdminPermissionsForSelectedTenant: function hasAdminPermissionsForSelectedTenant() {
      if ((this.selectedTenant || {}).hasAdminPermissions) {
        return true;
      } // in case the user has no admin-permissions, these 2 UI-options are hidden,
      // so also reset them to prevent any accidental side-effects
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties


      this.usersIncludeAncestorAdmins = false; // eslint-disable-next-line vue/no-side-effects-in-computed-properties

      this.usersIncludeSubAccounts = false;
      return false;
    },
    hasUserCreatePermissions: function hasUserCreatePermissions() {
      return this.hasAdminPermissionsForSelectedTenant || (this.selectedTenant || {}).hasUserCreatePermissions;
    },
    userReadAccesses: function userReadAccesses() {
      // find the user-accesses that have UserManagement.read permission
      return uniqBy(this.sessionAccess.filter(function (access) {
        return access.roles.find(function (role) {
          return role.Rules.find(function (rule) {
            return rule.subject.indexOf('UserManagement') >= 0 && rule.actions.indexOf('read') >= 0 || rule.subject.indexOf('all') >= 0 && rule.actions.indexOf('read') >= 0;
          });
        });
      }).concat(this.userManagementAccesses), function (access) {
        return access.scopeId;
      });
    },
    userCreateAccesses: function userCreateAccesses() {
      // find the user-accesses that have UserManagement.create permission
      return uniqBy(this.sessionAccess.filter(function (access) {
        return access.roles.find(function (role) {
          return role.Rules.find(function (rule) {
            return rule.subject.indexOf('UserManagement') >= 0 && rule.actions.indexOf('create') >= 0;
          });
        });
      }).concat(this.userManagementAccesses), function (access) {
        return access.scopeId;
      });
    },
    userManagementAccesses: function userManagementAccesses() {
      // find the user-accesses that have UserManagement.manage permission
      return this.sessionAccess.filter(function (access) {
        return access.roles.find(function (role) {
          return role.Rules.find(function (rule) {
            return rule.subject.indexOf('UserManagement') >= 0 && rule.actions.indexOf('manage') >= 0 || rule.subject.indexOf('all') >= 0 && rule.actions.indexOf('manage') >= 0;
          });
        });
      });
    },
    tenantManageIds: function tenantManageIds() {
      if (!this.sessionAccess) {
        return [];
      }

      if (this.$store.state.app.permissions['all.manage.tenantIds'] !== undefined) {
        return this.$store.state.app.permissions['all.manage.tenantIds'];
      } // find the user-accesses that have all.manage permission


      return this.sessionAccess.filter(function (access) {
        return access.roles.find(function (role) {
          return role.Rules.find(function (rule) {
            return rule.subject.indexOf('all') >= 0 && rule.actions.indexOf('manage') >= 0;
          });
        });
      }).map(function (a) {
        return a.tenantId;
      });
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    tenantBreadcrumPath: function tenantBreadcrumPath() {
      var _this2 = this;

      if (this.selectedTenant && this.selectedTenant.name) {
        return this.tenantAncestorList(this.selectedTenant).map(function (t) {
          return {
            text: t.name,
            click: function click() {
              _this2.changedSelectedTenant([t.id]);
            }
          };
        });
      }

      return [];
    },
    getTablePage: function getTablePage() {
      return this.$store.state.app.tablePage;
    }
  }),
  watch: {
    tenants: function tenants(newVal) {
      if (newVal && newVal.length) {
        this.tenantsList = flattenAccountsTree(newVal[0]);
      }
    },
    tenantSearch: {
      handler: function handler(newVal, oldVal) {
        var _this3 = this;

        if (!newVal) {
          this.open = [];
          this.accountsFilterEmpty = false;
          return;
        }

        if (oldVal !== newVal) {
          this.openFilteredTreeNodes(this.tenantSearch || '');
          this.$nextTick(function () {
            var treeViewElement = get(_this3.$refs, 'accountTreeView.$children[0].$el', null);

            if (treeViewElement && treeViewElement.classList.contains('v-treeview-node--excluded')) {
              _this3.accountsFilterEmpty = true;
            } else {
              _this3.accountsFilterEmpty = false;
            }
          });
        }
      }
    },
    selectedTenant: function selectedTenant() {
      this.active = [(this.selectedTenant || {}).id].filter(function (t) {
        return t;
      });
    }
  },
  mounted: function mounted() {
    this.fetchAndPrepareData();
  },
  methods: {
    get: get,
    filterTree: function filterTree(item, search, textKey) {
      // eslint-disable-next-line eqeqeq
      return item[textKey].toLowerCase().indexOf(search.toLowerCase()) >= 0 || item.id == search;
    },
    // debounce by 250ms to wait for the user to finish typing
    openFilteredTreeNodes: debounce(function (filter) {
      var _this4 = this;

      var found = this.tenantsList.filter(function (item) {
        // eslint-disable-next-line eqeqeq
        return item.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0 || item.id == filter;
      });
      var ids = [];
      found.forEach(function (account) {
        var result = getParents(_this4.tenantsList, account); // using Set to automatically remove duplicates

        ids = _toConsumableArray(new Set([].concat(_toConsumableArray(ids), _toConsumableArray(result))));
      });
      this.open = Array.from(ids).sort(function (a, b) {
        return a - b;
      });
    }, 250),
    loadMore: function () {
      var _loadMore = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$router.push({
                  path: '/account-mgmt/'
                });
                _context.next = 3;
                return this.$store.commit('app/openedTreeview', []);

              case 3:
                this.itemsLoadMore = false;
                this.active = [];
                this.open = [];
                this.tenants = [];
                this.selectedTenant = null;
                _context.next = 10;
                return this.fetchAndPrepareData();

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadMore() {
        return _loadMore.apply(this, arguments);
      }

      return loadMore;
    }(),
    openTreeView: function openTreeView() {
      var _this5 = this;

      var openIds = [];

      if ((this.openedTreeview || []).length) {
        // if vuex store has opened tree nodes stored, use them
        openIds = this.openedTreeview;
      } else if (this.active[0]) {
        // else if the route has an active tenant, open all its parents
        var activeTenant = this.tenantsList.filter(function (item) {
          return item.id === parseInt(_this5.active[0]);
        });

        if (activeTenant[0]) {
          var parents = this.tenantAncestorList(activeTenant[0]);
          openIds = parents.map(function (item) {
            return item.id;
          });
        }
      }

      this.open = openIds;
      this.itemsLoadMore = true;
    },
    setSelectedUserAfterCreation: function setSelectedUserAfterCreation(payload) {
      this.refreshTenants();
      this.selectedTenant = {
        id: payload.data.id
      };
    },
    breadCrumbsPath: function breadCrumbsPath() {
      return this.tenantBreadcrumPath;
    },
    tenantHandleSubmit: function tenantHandleSubmit() {
      this.$refs.tenantDetails.handleSubmit();
    },
    fetchAndPrepareData: function fetchAndPrepareData() {
      var _this6 = this;

      // the tenant can only be edited by an "admin" on a certain scope
      this.hasTenantManagePermission = this.tenantManageIds.length > 0;
      this.loadTenantsForTree().then(function () {
        if (_this6.$route.params.tenantId) {
          _this6.active = [_this6.$route.params.tenantId];

          if (_this6.$route.query.userlist !== undefined) {
            _this6.tabItem = 'tabUserList';
          } else {
            _this6.tabItem = 'tabTenantDetails';
          }

          _this6.openTreeView();
        }

        if (_this6.active.length === 0 && _this6.selectedTenant) {
          _this6.active = [_this6.selectedTenant.id];
        }
      }).catch(function (error) {
        if (error.response && _this6.$i18n_t("Error.".concat(error.response.data.message))) {
          _this6.$snack(_this6.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this6.$snack(_this6.$i18n_t('Common.tenantReadFail'), 'error');
        }
      });
    },
    loadTenantsForTree: function loadTenantsForTree() {
      var _this7 = this;

      var adminAccountsPromises = Promise.all(this.tenantManageIds.map(function (tenantId) {
        return ApiService.tenantGetById(tenantId, ['no-scope-descendents']);
      }));
      var otherUserReadAccesses = this.userReadAccesses.filter(function (access) {
        // first filter out all admin-account user-accesses
        return _this7.tenantManageIds.findIndex(function (tenantId) {
          return tenantId === access.tenantId;
        }) < 0;
      });
      var scopesPromises = Promise.all(otherUserReadAccesses.map(function (access) {
        return ApiService.getScope(access.scopeId);
      }));
      return Promise.all([adminAccountsPromises, scopesPromises]).then(function (allData) {
        var accountTree = allData[0];
        var scopes = allData[1];
        accountTree.forEach(function (account) {
          if (!account.data) {
            account.data = {};
          }
        }); // for all the other accounts, first check if they are already part of the tree
        // i.e. for an account permissions were given, but an ancestor-account already has admin-permissions,
        // so that account already exists in the tree

        scopes.forEach(function (scope) {
          if (!_this7.findTenantInTreeArray(accountTree, scope.tenant.id)) {
            if (!scope.data) {
              scope.data = {};
            } // it may be that a user-access object is not on ACCOUNT-level, in those cases overwrite the scope-id
            // it is a little dirty, but this scopeId is used by the user/api-key list, which works seamlessly then


            scope.scopeId = scope.id; // `isScope` is a flag to distinguish sub-scopes from ACCOUNT-scopes
            // so all of these are scopes, but for account-scopes no distinction needs to be done

            scope.isScope = scope.tenant.scopeId !== scope.id; // the tenant-id is used by the user-list
            // it is ALSO displayed in the tree as ID of this "account/scope".
            // MAY cause confusion since the scope-id is different after all, but when mixing scopes and accounts,
            // at least it is consistent to always show the account-id

            scope.id = scope.tenant.id;
            accountTree.push(scope);
          }
        });
        accountTree.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });

        if (!_this7.selectedTenant && accountTree.length > 0) {
          _this7.selectedTenant = accountTree[0];
        } else if (_this7.selectedTenant) {
          _this7.selectedTenant = _this7.findTenantInTreeArray(accountTree, _this7.selectedTenant.id) || _this7.selectedTenant;
        }

        _this7.checkForAdminPermissionsForSelectedTenant();

        _this7.tenants = accountTree;
        return accountTree;
      }).catch(function (error) {
        if (error.response && _this7.$i18n_t("Error.".concat(error.response.data.message))) {
          _this7.$snack(_this7.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this7.$snack(_this7.$i18n_t('Common.tenantReadFail'), 'error');
        }
      }).finally(function () {
        _this7.$store.state.app.loading = false;
      });
    },
    checkForAdminPermissionsForSelectedTenant: function checkForAdminPermissionsForSelectedTenant() {
      var _this8 = this;

      // trivial check for "root-accounts"
      if (this.tenantManageIds.findIndex(function (tenantId) {
        return tenantId === _this8.selectedTenant.id;
      }) >= 0) {
        this.selectedTenant.hasAdminPermissions = true; // force a UI-refresh now

        this.selectedTenant = _objectSpread({}, this.selectedTenant);
        return;
      } // further check for all sub-accounts


      ApiService.checkAccesses([{
        subject: 'all',
        action: 'manage'
      }, {
        subject: 'UserManagement',
        action: 'create'
      }], {
        scopeId: this.selectedTenant.scopeId
      }).then(function (res) {
        // if flagged as scope, this is not an account, so it cannot have account-admin-permissions
        _this8.selectedTenant.hasAdminPermissions = _this8.selectedTenant.isScope ? false : res['all.manage'];
        _this8.selectedTenant.hasUserCreatePermissions = res['UserManagement.create']; // force a UI-refresh now

        _this8.selectedTenant = _objectSpread({}, _this8.selectedTenant);
      }).catch(function () {
        _this8.selectedTenant.hasAdminPermissions = false; // force a UI-refresh now

        _this8.selectedTenant = _objectSpread({}, _this8.selectedTenant);
      });
    },
    addNew: function addNew() {
      if (this.selectedTenant) {
        this.tenantCreateDialog = true;
      }
    },
    addNewUser: function addNewUser() {
      if (this.selectedTenant) {
        this.isDialogCreateUserOpen = true;
      }
    },
    deleteTenant: function deleteTenant(id) {
      var _this9 = this;

      ApiService.tenantDelete(this, id).then(function () {
        _this9.$snack(_this9.$i18n_t('Common.tenantDeleteSuccess'), 'success');

        _this9.refreshTenants();

        _this9.tenantSearch = '';
        _this9.selectedTenant = _this9.tenants[0];
      }).catch(function (error) {
        console.error('Tenant delete fail', error);

        if (error.response && _this9.$i18n_t("Error.".concat(error.response.data.message))) {
          _this9.$snack(_this9.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this9.$snack(_this9.$i18n_t('Common.tenantDeleteFail'), 'error');
        }
      });
    },
    userBulkcreate: function userBulkcreate() {
      this.$router.push("/account-mgmt/user-bulk-create/".concat(this.selectedTenant.id));
    },
    refreshTenants: function refreshTenants() {
      this.fetchAndPrepareData();
      this.tenantCreateDialog = false;
    },
    tenantTreeIcon: function tenantTreeIcon(tenant) {
      if (tenant.isScope) {
        return 'fal fa-key';
      }

      var hasVisibleParent = tenant.parentId && !!this.findTenantInTreeArray(this.tenants, tenant.parentId);
      return !hasVisibleParent ? 'fal fa-users' : !tenant.children || tenant.children.length === 0 ? 'fal fa-user' : 'fal fa-user-friends';
    },
    tenantTreeLabelClass: function tenantTreeLabelClass(item) {
      var activeColor = this.color;
      return get(this.selectedTenant, 'id') === get(item, 'id') ? "".concat(activeColor, "--text text-bold") : '';
    },
    tenantAncestorList: function tenantAncestorList(tenant) {
      var _this10 = this;

      var findParents = function findParents(t) {
        if (t && t.parentId) {
          var parent = _this10.findTenantInTreeArray(_this10.tenants, parseInt(t.parentId));

          if (parent) {
            return findParents(parent).concat([parent]);
          }
        }

        return [];
      };

      return cloneDeep(findParents(tenant).concat([tenant]));
    },
    changedSelectedTenant: function changedSelectedTenant(tenantIds) {
      if (!tenantIds.length || !this.tenants || !this.tenants.length) {
        return;
      }

      this.selectedTenant = this.findTenantInTreeArray(this.tenants, parseInt(tenantIds[0]));
      this.checkForAdminPermissionsForSelectedTenant();
      EventBus.$emit('update-breadcrumbs');
    },
    findTenantInTreeArray: function findTenantInTreeArray(treeArray, tenantId) {
      for (var i = 0; i < treeArray.length; i++) {
        var foundTenant = this.findTenantInTree(treeArray[i], tenantId);

        if (foundTenant) {
          return foundTenant;
        }
      }

      return null;
    },
    findTenantInTree: function findTenantInTree(tree, tenantId) {
      if (tree.id === tenantId) {
        return tree;
      }

      if (tree.children && tree.children.length > 0) {
        return this.findTenantInTreeArray(tree.children, tenantId);
      }

      return null;
    },
    editUser: function editUser(user) {
      var openedTreeviewIds = [];
      this.tenantAncestorList(this.selectedTenant).forEach(function (item) {
        openedTreeviewIds.push(item.id);
      });
      this.$store.commit('app/openedTreeview', openedTreeviewIds);
      this.$router.push({
        path: "/account-mgmt/user/".concat(this.selectedTenant.id, "/").concat(user ? user.id : '')
      });
    },
    createUser: function createUser(data) {
      var _this11 = this;

      // as username, use the email. It is the same anyway
      data.username = data.email;
      var tenantId = parseInt(this.active[0]);
      ApiService.createUser(tenantId, data).then(function () {
        _this11.$snack(_this11.$i18n_t('accMgmt.user.createSuccessSnack'), 'success');

        _this11.closeUserDialog();
      }).catch(function (error) {
        if (error.response && _this11.$i18n_te("Error.".concat(error.response.data.message))) {
          _this11.$snack(_this11.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this11.$snack(_this11.$i18n_t('accMgmt.user.createFailedSnack'), 'error');
        }
      });
    },
    close: function close() {
      this.tenantCreateDialog = false;
    },
    closeUserDialog: function closeUserDialog() {
      this.isDialogCreateUserOpen = false;
      this.counter++;
    },
    activeItem: function activeItem(id) {
      this.$store.commit('app/setTablePage', 1);
      this.$router.replace({
        query: {
          active: id
        }
      });
    },
    goToConnectors: function goToConnectors() {
      this.$router.push({
        path: '/connectors/list'
      });
    }
  }
};